import { render, staticRenderFns } from "./UpdateAssetButton.vue?vue&type=template&id=61787daf&"
import script from "./UpdateAssetButton.vue?vue&type=script&lang=js&"
export * from "./UpdateAssetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61787daf')) {
      api.createRecord('61787daf', component.options)
    } else {
      api.reload('61787daf', component.options)
    }
    module.hot.accept("./UpdateAssetButton.vue?vue&type=template&id=61787daf&", function () {
      api.rerender('61787daf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/AssetTracking/Buttons/UpdateAssetButton.vue"
export default component.exports